import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
    BillingCompaniesPicker,
    BillingCompaniesPickerSchema,
} from './BillingCompaniesPicker';

export const BillingCompaniesPickerExtension = scaffolderPlugin.provide(
    createScaffolderFieldExtension({
        name: 'BillingCompaniesPicker',
        component: BillingCompaniesPicker,
        schema: BillingCompaniesPickerSchema as CustomFieldExtensionSchema,
    }),
);